import React, { useEffect } from 'react';
import Hero from '../../components/Hero/Hero';
import WhatWeDo from '../../components/WhatWeDo/WhatWeDo';
import CaseStudies from '../../components/CaseStudies/CaseStudies';
import WhyUs from '../../components/WhyUs/WhyUs';
import { initWOW, initParallax } from '../../utils/animations';

const Home = () => {
  useEffect(() => {
    initWOW();
    initParallax();
  }, []);

  return (
    <div>
      <Hero />
      <WhatWeDo />
      <CaseStudies />
      <WhyUs />
      
      {/* Logos Marquee */}
      <div className="logos-marquee-wrapper home-marquee">
        <div className="logos-marquee">
          {/* Duplicate logos for seamless loop */}
          {[...Array(3)].map((_, setIndex) => (
            <div key={`set-${setIndex}`} className="logos-marquee-set">
              {[
                '3ds-Max-Logo--Streamline-Logos.svg',
                'adobe-photoshop.svg',
                'Octicons-mark-github.svg',
                'substance-painter.svg',
                'Unity_Technologies-Logo.wine.svg',
                'unreal-engine-svgrepo-com.svg',
                'Zbrush_Logo.svg'
              ].map((logo, index, array) => (
                <div 
                  key={`logo-${setIndex}-${index}`} 
                  className="logo-item"
                  style={index === array.length - 1 ? { marginRight: '4rem' } : {}}
                >
                  <img 
                    src={`/images/${logo}`} 
                    alt="Partner logo" 
                    className="logo-image"
                    style={logo === 'Unity_Technologies-Logo.wine.svg' ? { transform: 'scale(1.3)' } : {}}
                  />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Home;

